










































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import MessageDialog from "@/components/modal/MessageDialog.vue";
import { estadosList, EstadoModel } from "@/models/commons/EstadoModel";
import { moneyMaskProperties } from "@/models/VuetifyMoneyModel";
import PrecoModel from "@/models/cadastros/assistencia/precificacao/PrecoModel";
import { tiposServicoList } from "@/models/cadastros/assistencia/TipoServicoModel";
import { tiposVeiculoList } from "@/models/cadastros/assistencia/TipoVeiculoModel";
import ServicosAssistenciaService from "@/service/assistencia24h/ServicosAssistenciaService";
import { saudeCidadeService } from "@/service/cadastro/saude/cidade/SaudeCidadeService";
import { saudeBairroService } from "@/service/cadastro/saude/bairro/SaudeBairroService";
import CidadeModel from "@/models/cadastros/saude/CidadeModel";
import { BairroModel } from "@/models/cadastros/saude/BairroModel";
import GsModalDialog from "@/components/modal/GsModalDialog.vue";

@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
    MessageDialog,
    GsModalDialog
  },
})
export default class CadastroPrecificacao extends Vue {
  $refs!: {
    precoObserver: InstanceType<typeof ValidationObserver>;
  };

  // preco:PrecificacaoModel = {
  //   id:undefined,
  //   cidade: undefined,
  //   especialidade: undefined,
  //   precoAssociado: undefined
  //  }
  moneyMaskProperties = moneyMaskProperties;
  isEdit = false;
  mostrarSelectEspecialidade = true;
  estados = estadosList;
  cidades: string[] = [];
  bairros: string[] = [];
  estado?: EstadoModel = {
    sigla: "",
    nome: "",
  };

  tiposServico = tiposServicoList;
  tiposVeiculo = tiposVeiculoList;

  preco: PrecoModel = {
    cidade: '',
    bairro: ''
  };

  dialogType = "";
  showDialog = false;
  dialogTitle = "";
  dialogMessage = "";
  
  loading = false;
  mostrarCamposAdicionais = false;
  readOnlyValorFinal = false;

  @Watch("preco.tipoServico")
  tipoServicoHandle() {
    if (
      this.preco?.tipoServico?.name == "GUINCHO" ||
      this.preco?.tipoServico?.name == "TRANSPORTE_ASSOCIADO"
    ) {
      this.mostrarCamposAdicionais = true;
      this.readOnlyValorFinal = true;
    } else {
      this.mostrarCamposAdicionais = false;
      this.readOnlyValorFinal = false;
    }
  }

  mounted() {
    this.loadInfo();
  }

  get isTransporteAssociado() {
    return this.preco.tipoServico?.name === "TRANSPORTE_ASSOCIADO";
  }

  get isPrecoDistancia() {
    return (
      this.preco.tipoServico?.name === "TRANSPORTE_ASSOCIADO" ||
      this.preco.tipoServico?.name === "GUINCHO"
    );
  }

  valorFinal?: any = 0;

  @Watch("preco.margem")
  @Watch("preco.valorServico")
  valorFinalWatch() {
    if (this.preco?.margem && this.preco?.valorServico) {
      let valoServico = Number(this.preco?.valorServico);
      this.valorFinal =
        valoServico * (Number(this.preco?.margem) / 100) + valoServico;
      this.valorFinal = this.valorFinal.toFixed(2);
    }
  }

  @Watch("preco.estado")
  getCidades() {
    console.log(this.preco);
    if (!!this.preco.estado) {
      saudeCidadeService.obterCidadesPorEstado(this.preco.estado.sigla)
        .then((resp) => {
          this.cidades = resp.map((c: CidadeModel) => c.nome);
        })
    }
  }

  @Watch("preco.cidade")
  getBairros() {
    if (!!this.preco.cidade) {
      this.bairros = [];
      saudeBairroService.obterPorCidade(this.preco.cidade)
        .then(resp => {
          this.bairros = resp.map(b => b.nome);
        });
    }
  }

  gravar() {
    this.$refs.precoObserver.validate().then((valid) => {
      if (valid) {
        if (this.$route.params.idPrecificacao) {
          ServicosAssistenciaService.atualizarPreco(
            this.preco,
            Number(this.$route.params.idPrecificacao),
            this.valorFinal
          )
            .then((res: any) => {
              this.openDialog('success', 'Alterado', 'Alteração realizada com sucesso');
            })
            .catch((err: any) => {
              let msg = '';
              if (err.response?.data?.status == 400) {
                msg = err.response?.data?.detail;
              } else {
                msg = "Erro ao cadastrar preço para o associado";
              }
              this.openDialog('error', 'Erro', msg);
            });
        } else {
          ServicosAssistenciaService.salvarPreco(this.preco, this.valorFinal)
            .then((res) => {
              this.openDialog('success', 'Cadastrado', 'Cadastro de preço realizado com sucesso');
            })
            .catch((err) => {
              let msg = '';
              if (err.response?.data?.status == 400) {
                msg = err.response?.data?.detail;
              } else {
                msg = "Erro ao cadastrar preço para o associado";
              }
              this.openDialog('error', 'Erro', msg);
            });
        }
      }
    });
  }

  loadInfo() {
    if (this.$route.params.idPrecificacao) {
      this.loading = true;
      ServicosAssistenciaService.obterPrecoPorId(
        new Number(this.$route.params.idPrecificacao)
      )
        .then((res: any) => {
          this.loading = false;
          this.isEdit = true;
          this.preco = {
            id: res.data.id,
            tipoServico: this.tiposServico?.find(
              (tipo) => tipo.name == res.data.tipoServico
            ),
            tipoVeiculo: this.tiposVeiculo?.find(
              (tipo) => tipo.name == res.data.tipoVeiculo
            ),
            estado: this.estados?.find(
              (estado) => estado.sigla == res.data.estado
            ),
            cidade: res.data.cidade,
            bairro: res.data.bairro,
            kmOrigemDestino: res.data.kmOrigemDestino,
            valorServico: res.data.valorServico
              ? res.data.valorServico.toFixed(2)
              : undefined,
            margem: Number(res.data.margem) * 100,
            valorKmExcedido: res.data.valorKmExcedido
              ? res.data.valorKmExcedido.toFixed(2)
              : undefined,
          };
          this.valorFinal = res.data.valorFinal.toFixed(2);
        })
        .catch((err) => {
          this.loading = false;
        });
    }
  }

  toggleDistricts() {
    this.$nextTick(() => {
      // if (this.isAllDistrictsSelected()) {
      //   this.preco.bairro = [];
      // } else {
      //   this.preco.bairro = [...this.bairros];
      // }
    });
  }

  isAllDistrictsSelected(): boolean {
    return this.bairros.length == (this.preco.bairro?.length ?? 0) && !!this.preco.bairro?.length;
  }



  private openDialog(dialogType: string, title: string, message: string) {
    this.dialogType = dialogType;
    this.dialogTitle = title;
    this.dialogMessage = message;
    this.showDialog = true;
  }

  public closeDialog(): void {
    this.showDialog = false;
    if (this.dialogType === 'success') {
      this.$router.push({ name: "ListaPrecificacoes" });
    }
  }

  get btnColor() {
    let color: string;
    switch (this.dialogType) {
      case "success":
        color = "#00CD96";
        break;
      case "error":
        color = "error";
        break;
      case "confirm":
        color = "warning";
        break;
      default:
        color = "primary";
        break;
    }
    return color;
  }

  get btnText() {
    let text: string;
    switch (this.dialogType) {
      case "success":
        text = "Ok, entendi";
        break;
      case "error":
        text = "Fechar";
        break;
      case "confirm":
        text = "Cancelar";
        break;
      default:
        text = "Ok, entendi";
        break;
    }
    return text;
  }

  get dialogImg() {
    return `${this.dialogType}.png`;
  }
}
